import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Alert from '@mui/material/Alert';
import Table from 'react-bootstrap/Table';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { fetchToken } from '../../../Auth';
import { toast } from 'react-toastify';
import axios from 'axios';
import { adminURL } from '../../../global';
import { Autocomplete, TextField, Typography, Switch, Tabs, Tab } from "@mui/material";
import { styled } from "@mui/material/styles";
import { checkRoute } from '../../../services/auth';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : theme.palette.grey[300],
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const customStyles = {
  menu: (provided) => ({
    ...provided,
    maxHeight: "120px",
    zIndex: 1000,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "120px",
    zIndex: 1000,
  }),
  control: (provided, state) => ({
    ...provided,
    zIndex: 1000,
    "&:hover": {
      border: "1.25px solid #556",
    },
  }),
};

const UserManagement = () => {
  const [tabMode, setTabMode] = useState("manage");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState({ 'label': '', 'value': '' });
  const [newUsername, setNewUsername] = useState("");
  const [fullName, setFullName] = useState("")
  const [privileges, setPrivileges] = useState(null);
  const [userStatus, setUserStatus] = useState(false);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [assignedDashboards, setAssignedDashboards] = useState([]);
  const [dashboardOptions, setDashboardOptions] = useState([]);
  const [dashboardMap, setDashboardMap] = useState({});
  const navigate = useNavigate();

  const resetTabState = (newTabMode) => {
    if (newTabMode === "manage") {
      setNewUsername("");
      setFullName("")
      setPrivileges(null);
      setAssignedDashboards([]);
      setSuperAdmin(false);
      setUserStatus(false);
    } else if (newTabMode === "create") {
      setNewUsername("");
      setFullName("")
      setSelectedUser({ 'label': '', 'value': '' });
      setPrivileges(null);
      setUserStatus(false);
      setAssignedDashboards([]);
      setSuperAdmin(false);
    }
  };

  const getUsers = async () => {
    try {
      const response = await axios.get(`/get_auth_users`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
      if (response.status === 200 && response.data !== undefined) {
        setUsers(response.data);
      }
    } catch (err) {
      console.error("Error", err);
      if (err.response.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`);
      }
    }
  };

  const getPrivileges = async () => {
    try {
      const response = await axios.get(`/get_privileges_for_user/${selectedUser['value']}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
      if (response.status === 200 && response.data !== undefined) {
        let privlege_data = response.data.privileges;
        let userStatus = response.data.isActive;
        const assigned = dashboardOptions.filter((d) => privlege_data[d.value]);
        setAssignedDashboards(assigned);
        setPrivileges(privlege_data);
        setUserStatus(userStatus);
        setSuperAdmin(response.data.superAdmin);
      }
    } catch (err) {
      console.error("Error", err);
      if (err.response.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`);
      }
    }
  };

  const getDashboards = async () => {
    try {
      const response = await axios.get(`/get_dashboards/active`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
      if (response.status === 200 && response.data !== undefined) {
        const dashboards = response.data.dashboards;
        const dashboardObj = dashboards.reduce((acc, dashboard) => {
          acc[dashboard._id] = dashboard.dashboard;
          return acc;
        }, {});
        setDashboardMap(dashboardObj);
        setDashboardOptions(dashboards.map(d => ({ label: d.dashboard, value: d._id })));
      }
    } catch (err) {
      console.error("Error", err);
      if (err.response.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`);
      }
    }
  };

  const isSuperAdmin = async () => {
    try {
      const response = await axios.get(`/is_super_admin`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
      if (response.status === 200 && response.data !== undefined) {
        if (!response.data) {
          navigate('/error');
        }
      }
    } catch (err) {
      console.error("Error", err);
      if (err.response.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`);
      }
    }
  };

  const createNewUser = async () => {
    if (!newUsername) {
      toast.error('Please enter a username!');
      return;
    }
    if (!fullName) {
      toast.error('Please enter the Full Name !');
      return;
    }
    const emailRegex = /^[^\s@]+@(sciative\.com|sciative\.in)$/i;
    if (!emailRegex.test(newUsername)) {
      toast.error('Username must be a valid email ending with @sciative.com or @sciative.in!');
      return;
    }

    const assignedDashboardValues = assignedDashboards.map(dashboard => dashboard.value);
    if (assignedDashboardValues.length == 0) {
      toast.error('Assign atleast one dashboard!');
      return;
    }
    const privilege = Object.keys(privileges || {})
      .filter(key => assignedDashboardValues.includes(parseInt(key)))
      .reduce((acc, key) => {
        acc[key] = privileges[key];
        return acc;
      }, {});

    try {
      const response = await axios.post(`/create_new_user`, {
        username: newUsername,
        fullName: fullName,
        privilege,
        superAdmin,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
      if (response.status === 200 && response.data !== undefined) {
        toast.success(`User ${newUsername} created successfully!`);
        setNewUsername("");
        setFullName("")
        setPrivileges(null);
        setAssignedDashboards([]);
        setSuperAdmin(false);
        getUsers()
      }
    } catch (err) {
      console.error("Error", err);
      toast.error(err.response.data.msg);
      if (err.response.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`);
      }
      if (err.response.status === 500) {
        toast.error(`Something went wrong!`);
      }
    }
  };
  useEffect(() => {
    const verifyRoute = async () => {
      try {
        const response = await checkRoute(navigate, adminURL);
        console.log('Route check response:', response);
      } catch (err) {
        console.log('Route check failed:', err);
      }
    };

    verifyRoute();
  }, [navigate, adminURL]);


  useEffect(() => {
    getDashboards();
    isSuperAdmin();
    getUsers();
  }, []);

  useEffect(() => {
    if (tabMode === "manage" && selectedUser['value']) {
      getPrivileges();
    }
  }, [selectedUser]);

  useEffect(() => {
    resetTabState(tabMode);
  }, [tabMode]);

  const handleChange = (checked, content, action) => {
    setPrivileges(prevState => {
      const temp = { ...prevState || {} };
      temp[content] = { ...temp[content] || {} };
      temp[content][action] = checked;
      return temp;
    });
  };

  const savePrivilege = async () => {
    if (!selectedUser['value']) {
      toast.error('Select a user!');
      return;
    }
    const assignedDashboardValues = assignedDashboards.map(dashboard => dashboard.value);
    const privilege = Object.keys(privileges)
      .filter(key => assignedDashboardValues.includes(parseInt(key)))
      .reduce((acc, key) => {
        acc[key] = privileges[key];
        return acc;
      }, {});

    try {
      const response = await axios.post(`/edit_privileges_for_user`, {
        user_id: selectedUser['value'],
        privilege,
        status: userStatus,
        superAdmin: superAdmin,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
      if (response.status === 200 && response.data !== undefined) {
        toast.success(`Privileges set successfully for ${selectedUser['label']}!`);
      }
    } catch (err) {
      toast.error(err.response.data.msg);
      console.error("Error", err);
      if (err.response.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`);
      }
      if (err.response.status === 500) {
        toast.error(`Something went wrong!`);
      }
    }
  };

  const removeAllAccess = () => {
    setPrivileges((prevState) => {
      const temp = { ...prevState || {} };
      Object.keys(temp).forEach((contentKey) => {
        temp[contentKey] = { create: false, makeLive: false, edit: false, delete: false };
      });
      return temp;
    });
  };

  const grantAllAccess = () => {
    setPrivileges((prevState) => {
      const temp = { ...prevState || {} };
      Object.keys(temp).forEach((contentKey) => {
        temp[contentKey] = { create: true, makeLive: true, edit: true, delete: true };
      });
      return temp;
    });
  };

  const handleDashboardChange = (event, selectedOptions) => {
    console.log('value')
    setAssignedDashboards(selectedOptions);
    setPrivileges((prevPrivileges) => {
      const updatedPrivileges = { ...prevPrivileges || {} };
      selectedOptions.forEach((dashboard) => {
        if (!updatedPrivileges[dashboard.value]) {
          updatedPrivileges[dashboard.value] = {
            create: false,
            makeLive: false,
            edit: false,
            delete: false,
          };
        }
      });
      return updatedPrivileges;
    });
  };

  return (
    <>
      <section className='w-100 row p-2'>
        <div className='admin-card corner row p-3 shadow-2 w-100'>
          <div className='col-1'></div>
          <div className='col-8'>
            <h1 className='bold'>User Management</h1>
            <p className='medium-3 text-muted'>Manage privileges for users.</p>
          </div>
        </div>

        {/* <div className='mt-3 admin-card corner row p-3 mb-5 shadow-2 w-100'> */}
        <div className='mt-3  corner row p-3 mb-5 shadow-2 w-100'>
          <Tabs value={tabMode} onChange={(e, newValue) => setTabMode(newValue)}
            TabIndicatorProps={{ style: { display: "none" } }}
            sx={{
              backgroundColor: "#f5f5f5",
              borderRadius: 2,
              padding: "4px",
            }}
          >
            <Tab label="Manage User" value="manage" sx={{
              backgroundColor: tabMode === "manage" ? "#FFC508" : "transparent",
              color: tabMode === "manage" ? "#fff !important" : "#000 !important",
              borderRadius: 1,
              textTransform: "none",
              fontWeight: "bold",
              mx: 1, 
            }} />

            <Tab label="Create User" value="create"
              sx={{
                backgroundColor: tabMode === "create" ? "#FFC508" : "transparent",
                color: tabMode === "create" ? "#fff !important" : "#000 !important",
                borderRadius: 1,
                textTransform: "none",
                fontWeight: "bold",
                mx: 1,
              }} />
          </Tabs>

          <div className='col-12 row mt-3'>
            <div className='col-6'>
              {tabMode === "manage" ? (
                <>
                  <h6 className='bold'>Select a user</h6>
                  <Select
                    placeholder="Select User"
                    value={selectedUser}
                    closeMenuOnSelect={true}
                    onChange={(selectedOption) => setSelectedUser(selectedOption)}
                    options={users.map(user => ({ value: user.userId, label: user.username }))}
                    styles={customStyles}

                  />
                </>
              ) : (
                <>
                  <h6 className='bold'>Enter Username</h6>
                  <TextField
                    fullWidth
                    size="small"
                    value={newUsername}
                    onChange={(e) => setNewUsername(e.target.value)}
                    label="xyz@sciative.com or .in"
                    variant="outlined"
                  />
                  <h6 className='bold mt-2'>Enter Name</h6>
                  <TextField
                    fullWidth
                    size="small"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    label="Full Name"
                    variant="outlined"
                  />

                </>
              )}
            </div>
            {/* <div className='col-6 d-flex justify-content-evenly align-items-end'>
              <Button
                disabled={(tabMode === "manage" && !selectedUser['value']) || (tabMode === "create" && !newUsername)}
                onClick={grantAllAccess}
                className='w-30'
                variant="outline"
                size='sm'
              >
                <i className="mr-2 fa-regular fa-circle-check"></i> Grant All
              </Button>
              <Button
                disabled={(tabMode === "manage" && !selectedUser['value']) || (tabMode === "create" && !newUsername)}
                onClick={removeAllAccess}
                className='w-30'
                variant="outline"
                size='sm'
              >
                <i className="mr-2 fa-regular fa-circle-xmark"></i> Remove All
              </Button>
              <Button
                disabled={(tabMode === "manage" && !selectedUser['value']) || (tabMode === "create" && !newUsername)}
                onClick={tabMode === "manage" ? savePrivilege : createNewUser}
                className='w-30'
                variant="contained"
                size='sm'
              >
                <i className="mr-2 fa-solid fa-user-lock"></i> {tabMode === "manage" ? "Save" : "Create"}
              </Button>
            </div> */}
            <div className='col-6 d-flex justify-content-evenly align-items-start pt-4'>
              <Button
                disabled={(tabMode === "manage" && (!selectedUser['value'] || assignedDashboards.length == 0)) || (tabMode === "create" && (!newUsername || assignedDashboards.length == 0))}
                onClick={grantAllAccess}
                className='w-30 align-self-start'
                variant="outline"
                size='sm'
              >
                <i className="mr-2 fa-regular fa-circle-check"></i> Grant All
              </Button>
              <Button
                disabled={(tabMode === "manage" && (!selectedUser['value'] || assignedDashboards.length == 0)) || (tabMode === "create" && (!newUsername || assignedDashboards.length == 0))}
                onClick={removeAllAccess}
                className='w-30 align-self-start'
                variant="outline"
                size='sm'
              >
                <i className="mr-2 fa-regular fa-circle-xmark"></i> Remove All
              </Button>
              <Button
                disabled={(tabMode === "manage" && !selectedUser['value']) || (tabMode === "create" && !newUsername)}
                onClick={tabMode === "manage" ? savePrivilege : createNewUser}
                className='w-30 align-self-start'
                variant="contained"
                size='sm'
              >
                <i className="mr-2 fa-solid fa-user-lock"></i> {tabMode === "manage" ? "Save" : "Create"}
              </Button>
            </div>

          </div>

          <div className="mt-4 col-12">
            {(tabMode === "manage" && privileges && selectedUser["value"]) || (tabMode === "create" && newUsername) ? (
              <>
                <div className="col-12 mb-3 d-flex justify-content-between">
                  <div className='col-6'>
                    <h6 className="bold">Assign Dashboards</h6>
                    <Autocomplete
                      size="small"
                      multiple
                      options={dashboardOptions}
                      value={assignedDashboards}
                      onChange={handleDashboardChange}
                      renderInput={(params) => <TextField {...params} label="Select Dashboards" />}
                    />
                  </div>
                  <div>
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '5em' }}>
                      <Typography sx={{ mx: 1 }}>Super Admin</Typography>
                      <IOSSwitch checked={superAdmin} onChange={() => setSuperAdmin(!superAdmin)} />
                    </div>
                    {tabMode === "manage" && (
                      <div className="d-flex justify-content-center align-items-center" style={{ height: '5em' }}>
                        <Typography sx={{ mx: 1 }}>Inactive</Typography>
                        <IOSSwitch checked={userStatus} onChange={() => setUserStatus(!userStatus)} />
                        <Typography sx={{ mx: 1 }}>Active</Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div>Dashboard Access Level</div>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Content</th>
                      <th>Create</th>
                      <th>Edit</th>
                      <th>Make Live</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>

                    {assignedDashboards.map((dashboard) => {
                      const dashboardId = dashboard.value;
                      return (

                        <tr key={dashboardId}>
                          <td className="bold">{dashboard.label}</td>
                          {["create", "edit", "makeLive", "delete"].map((actionType) => (
                            <td key={`${dashboardId}-${actionType}`}>
                              <Checkbox
                                onChange={(evt) =>
                                  handleChange(evt.target.checked, dashboardId, actionType)
                                }
                                checked={privileges?.[dashboardId]?.[actionType] || false}
                              />
                            </td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </>
            ) : (
              <Alert className="mt-2 mb-5 w-100" severity="info">
                {tabMode === "manage" ? "Select a user." : "Enter a username."}
              </Alert>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default UserManagement;